import { useEffect, useRef } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/i18n";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/session", { session_id: sid })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [location.hash, navigate, setUser]);

  return null;
};

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { t } = useT();
  if (loading) return <div className="p-16 text-[#0F4C5C]" data-testid="auth-loading">{t("Loading your workspace…")}</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
